import { properties } from "@repoflow/common/schema-fields";

const { createdAt, updatedAt } = properties;

export { createdAt, updatedAt };

// The partition a capture lives in: the workflow it was filled against.
//
// Composite for the reason pagews' `siteKey` is (see
// projects/pagews/common/schema/site/key.js): `workflowId` is a slug the tenant
// chose, unique within an organization and nowhere else, so hashing on it
// alone would put two tenants' "onboarding" captures in one partition. The
// separator is a slash because `/Name/Required` forbids it, so no workflow name
// can forge a key belonging to another organization.
//
// Built here and nowhere else.
export const workflowKeyOf = (orgId, workflowId) => `${orgId}/${workflowId}`;

export const workflowKey = {
  type: "string",
};

// Redundant beside workflowKey, and deliberately so: a row that cannot say
// which organization and workflow it belongs to without being parsed is one a
// backfill or a person reading the table has to decode.
export const orgId = {
  type: "string",
};

export const workflowId = {
  label: "Workflow",
  type: "string",
};

// Minted, not chosen — a capture is never addressed by a person.
export const captureId = {
  label: "Response",
  type: "string",
};

// What was captured: one object per step, keyed by the step's `name`, each
// holding the values of that step's compiled form. Opaque here because its
// shape is decided by the workflow's own step declarations at the time of the
// capture — the same reason `Workflow.steps` is opaque in the table. The API
// checks that the keys are the workflow's step names and bounds the size; it
// does not compile the steps to validate the values (see docs/wfws.md).
export const values = {
  label: "Values",
  type: "object",
  default: {},
};

export const status = {
  type: "string",
};

// The published version the answers were given against — the row in
// workflow-versions-table whose steps the visitor saw. A version is never
// written again once published, so this is enough to read the answers back
// against exactly the declaration that asked for them, however many times the
// workflow has been published since.
export const version = {
  label: "Version",
  type: "integer",
  minimum: 1,
};

// When the version the answers were given against was published. Kept beside
// `version` for what it was first for: a reader of the row, or of the export,
// can tell when the declaration dates from without a second lookup.
export const definitionUpdatedAt = {
  label: "Captured against",
  type: "string",
  format: "date",
};
